import { Icon } from '@chakra-ui/react';

const Step2Icon = (props) => (
    <Icon
        width="72px"
        height="75px"
        viewBox="0 0 72 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="49.5" cy="22.6543" r="22.5" fill="#187672" />
        <circle cx="18" cy="54.1543" r="18" fill="#F09419" />
        <foreignObject x="9.90002" y="2.05432" width="53.2" height="72.2">
            <div
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                    WebkitBackdropFilter: 'blur(1.85px)',
                    backdropFilter: 'blur(1.85px)',
                    clipPath: 'url(#bgblur_0_2_679_clip_path)',
                    height: '100%',
                    width: '100%'
                }}
            />
        </foreignObject>
        <g filter="url(#filter0_d_2_679)" data-figma-bg-blur-radius="3.7">
            <path d="M23.4545 6.1543C19.3429 6.1543 16 9.51758 16 13.6543V58.6543C16 62.791 19.3429 66.1543 23.4545 66.1543H49.5455C53.6571 66.1543 57 62.791 57 58.6543V13.6543C57 9.51758 53.6571 6.1543 49.5455 6.1543H23.4545ZM32.7727 56.7793H40.2273C41.2523 56.7793 42.0909 57.623 42.0909 58.6543C42.0909 59.6855 41.2523 60.5293 40.2273 60.5293H32.7727C31.7477 60.5293 30.9091 59.6855 30.9091 58.6543C30.9091 57.623 31.7477 56.7793 32.7727 56.7793Z" fill="url(#paint0_linear_2_679)" shapeRendering="crispEdges" />
            <path d="M23.4545 6.1543C19.3429 6.1543 16 9.51758 16 13.6543V58.6543C16 62.791 19.3429 66.1543 23.4545 66.1543H49.5455C53.6571 66.1543 57 62.791 57 58.6543V13.6543C57 9.51758 53.6571 6.1543 49.5455 6.1543H23.4545ZM32.7727 56.7793H40.2273C41.2523 56.7793 42.0909 57.623 42.0909 58.6543C42.0909 59.6855 41.2523 60.5293 40.2273 60.5293H32.7727C31.7477 60.5293 30.9091 59.6855 30.9091 58.6543C30.9091 57.623 31.7477 56.7793 32.7727 56.7793Z" stroke="url(#paint1_linear_2_679)" strokeWidth="0.2" shapeRendering="crispEdges" />
        </g>
        <defs>
            <filter id="filter0_d_2_679" x="9.90002" y="2.05432" width="53.2" height="72.2" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.37 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_679" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_679" result="shape" />
            </filter>
            <clipPath id="bgblur_0_2_679_clip_path" transform="translate(-9.90002 -2.05432)"><path d="M23.4545 6.1543C19.3429 6.1543 16 9.51758 16 13.6543V58.6543C16 62.791 19.3429 66.1543 23.4545 66.1543H49.5455C53.6571 66.1543 57 62.791 57 58.6543V13.6543C57 9.51758 53.6571 6.1543 49.5455 6.1543H23.4545ZM32.7727 56.7793H40.2273C41.2523 56.7793 42.0909 57.623 42.0909 58.6543C42.0909 59.6855 41.2523 60.5293 40.2273 60.5293H32.7727C31.7477 60.5293 30.9091 59.6855 30.9091 58.6543C30.9091 57.623 31.7477 56.7793 32.7727 56.7793Z" />
            </clipPath><linearGradient id="paint0_linear_2_679" x1="16" y1="6.1543" x2="55.8488" y2="67.4334" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
            </linearGradient>
            <linearGradient id="paint1_linear_2_679" x1="17.1927" y1="6.1543" x2="55.2411" y2="65.9453" gradientUnits="userSpaceOnUse">
                <stop stopColor="white" />
                <stop offset="1" stopOpacity="0" />
            </linearGradient>
        </defs>

    </Icon>
);

export default Step2Icon;
